import { db } from '../firebase'

export const getListsByUsersEmail = email => db.collection('lists').where("readers", "array-contains", email).get()
export const deleteList = listid => db.collection('lists').doc(listid).delete()
export const createList = list => db.collection('lists').add(list)
export const updateList = list => db.collection('lists').doc(list.id).update({
  ...list
})